import { ApprovalTerm } from 'api/application'

export function getMinAPR(approvalTerms: ApprovalTerm[]) {
    return approvalTerms.reduce((min, approvalTerm: ApprovalTerm) => {
        const apr = Number(approvalTerm.apr)

        return apr < min ? apr : min
    }, 1000)
}
